import UnitDetail from './UnitDetail';

export default UnitDetail;
